import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-2" }
const _hoisted_3 = { class: "col-md-10" }
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "list-group" }

import { computed, onBeforeMount, reactive, ref, watch } from 'vue'
import { FormKitSelectOption } from '@/types/app.tmp'
import { City, Store } from '@/types/api'
import { useStore } from "vuex";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";
import AppIconLoadingButton from "@/components/app/AppIconLoadingButton.vue";
import { promiseParallel } from "@/helpers/tools";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";

// @todo Check type
interface Model {
  cityId: string | null,
  storeId: number | null
}

interface Lock {
  loading: boolean,
  formSubmitting: boolean,
  filialRemovingId: string | number | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoFavouriteStores',
  setup(__props) {

const defaultModel = (): Model => ({
  cityId: null,
  storeId: null
})

const store = useStore()

const model = ref<Model>(defaultModel())

const lock = reactive<Lock>({ loading: false, formSubmitting: false, filialRemovingId: null })

const favouriteStoreIds = computed<number[]>((): number[] => store.getters['shopping/silpo/favouriteStores/ids'])

const cities = computed<City[]>((): City[] => store.getters['shopping/silpo/cities/list'])

const stores = computed<Store[]>((): Store[] => store.getters['shopping/silpo/stores/list'])

const cityOptions = computed<FormKitSelectOption[]>((): FormKitSelectOption[] => {
  return cities.value
      .map((city): FormKitSelectOption => ({
        label: city.name,
        value: city.id,
        attrs: {
          disabled: !city.active
        }
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
})

const storeOptions = computed<FormKitSelectOption[]>((): FormKitSelectOption[] => {
  const city = cities.value.filter((c) => c.id === model.value.cityId)[0]
  if (!city) return []

  return stores.value
      .filter((s) => s.city_id === city.city_id)
      .map((s) => ({
        value: s.filial_id,
        label: s.title,
        attrs: {
          disabled: !s.active
        }
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
})

const favouriteStores = computed(() => {
  const result: { city: City, stores: Store[] }[] = []

  if (favouriteStoreIds.value.length === 0) return []

  favouriteStoreIds.value.forEach((storeId) => {
    const _store = stores.value.filter((s) => s.filial_id === storeId)[0]
    if (!_store) return

    const city = cities.value.filter((c) => c.city_id === _store.city_id)[0]
    if (!city) return

    const cityInResult = result.filter((r) => r.city.id === city.id)[0]
    if (cityInResult) {
      cityInResult.stores.push(_store)
    } else {
      result.push({ city, stores: [_store] })
    }
  })

  return result.sort((a, b) => a.city.name.localeCompare(b.city.name))
})

watch(() => model.value.cityId, (): void => {
  model.value.storeId = storeOptions.value.filter((option) => !option.attrs?.disabled)[0].value as number
})

async function addToFavourite (): Promise<void> {
  lock.formSubmitting = true

  try {
    await store.dispatch('shopping/silpo/favouriteStores/toggleFavourite', parseInt('' + model.value.storeId))
  } finally {
    lock.formSubmitting = false
  }
}

async function removeStoreFromFavourites (filialId: string | number): Promise<void> {
  if (lock.filialRemovingId) return

  lock.filialRemovingId = filialId

  try {
    await store.dispatch('shopping/silpo/favouriteStores/toggleFavourite', parseInt('' + filialId))
  } finally {
    lock.filialRemovingId = null
  }
}

onBeforeMount(async (): Promise<void> => {
  await promiseParallel([
    { promise: () => store.dispatch('shopping/silpo/favouriteStores/init') },
    { promise: () => store.dispatch('shopping/silpo/cities/init') },
    { promise: () => store.dispatch('shopping/silpo/stores/init') },
  ], {
    beforeAll: () => lock.loading = true,
    afterAll: () => lock.loading = false,
  })

  // await Promise.all([
  //   store.dispatch('shopping/silpo/favouriteStores/init'),
  //   store.dispatch('shopping/silpo/cities/init'),
  //   store.dispatch('shopping/silpo/stores/init')
  // ],)
})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(cityOptions).length)
        ? (_openBlock(), _createBlock(_component_FormKit, {
            key: 0,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            type: "form",
            actions: false,
            onSubmit: addToFavourite
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                name: "cityId",
                type: "select",
                label: "Cities",
                placeholder: "Select city",
                options: _unref(cityOptions),
                "outer-class": "mb-3"
              }, null, 8, ["options"]),
              (_unref(storeOptions).length)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 0,
                    name: "storeId",
                    type: "select",
                    label: "Stores in city",
                    placeholder: "Select the store",
                    options: _unref(storeOptions),
                    "outer-class": "mb-3"
                  }, null, 8, ["options"]))
                : _createCommentVNode("", true),
              _createVNode(_component_FormKit, {
                type: "submit",
                disabled: !model.value.cityId || !model.value.storeId || _unref(favouriteStoreIds).includes(parseInt(model.value.storeId)),
                "input-class": "btn btn-primary btn-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(FormKitSubmitButtonContent, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Add to favorite")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (lock.loading)
        ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(favouriteStores), (favouriteCity) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `favourite-city-${favouriteCity.city.id}`,
                class: "col-md-6"
              }, [
                _createVNode(AppComponentHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(favouriteCity.city.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favouriteCity.stores, (favouriteStore) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `favourite-store-${favouriteStore.id}`,
                      class: "list-group-item d-flex justify-content-between"
                    }, [
                      _createTextVNode(_toDisplayString(favouriteStore.title) + " ", 1),
                      _createVNode(AppIconLoadingButton, {
                        icon: "trash",
                        loading: lock.filialRemovingId === favouriteStore.filial_id,
                        "button-type": "danger",
                        disabled: !!lock.filialRemovingId,
                        onClick: ($event: any) => (removeStoreFromFavourites(favouriteStore.filial_id))
                      }, null, 8, ["loading", "disabled", "onClick"])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})